const tableData = [
    {
        srNo: 1,
        name: 'Prof. N R Mandal',
        position: 'PRESIDENT'
    },
    {
        srNo: 2,
        name: 'Mr. Prerit Jain',
        position: 'GENERAL SECRETARY'
    },
    {
        srNo: 4,
        name: 'Mr. Karan Nandankar',
        position: 'ASSISTANT SECRETARY'
    },
    {
        srNo: 5,
        name: 'Mr. Ankit Raj',
        position: 'TREASURER'
    },
    {
        srNo: 6,
        name: 'Mr. Ishan',
        position: 'PUBLIC RELATIONS OFFICER'
    },
    {
        srNo: 7,
        name: 'Mr. Prabhat Ranjan',
        position: 'SCHOOL DEVELOPMENT OFFICER'
    },
    {
        srNo: 8,
        name: 'Mr. Kumar Aniket',
        position: 'CHIEF FUNDRAISING OFFICER'
    },
    {
        srNo: 9,
        name: 'Mr. Gursharan Ahir',
        position: 'HUMAN RESOURCE MANAGER'
    },
    {
        srNo: 10,
        name: 'Mr. Gaurav Singh',
        position: ' EXECUTIVE OFFICER [RS]'
    },
    {
        srNo: 11,
        name: 'Mr. Manoj Khojaram Maraskolhe',
        position: 'CHIEF EXECUTIVE OFFICER [LiGHT]'
    },
 
    // Add more data as needed
];

export default tableData;